import { realTimeWithCodePattern, rtsmWithCodePattern } from './constants';
import { ParamParseKey, PathMatch, PathPattern } from './context';
import {
  RTSM_ROUTE,
  RTSM_ROUTE_USER_V4,
  RTSM_ROUTE_USER_HASH,
  RTSM_ROUTE_USER_CODE_V4,
  REAL_TIME_CODE,
} from './routes';

export const isRtsm = (
  pathname: string,
  matchPath: <Path extends string>(pattern: PathPattern<Path> | Path, pathname: string) => PathMatch<ParamParseKey<Path>> | null
): boolean => !!(isRtsmWithCode(pathname, matchPath) || isRtsmUser(pathname, matchPath));

export const isRtsmUser = (
  pathname: string,
  matchPath: <Path extends string>(pattern: PathPattern<Path> | Path, pathname: string) => PathMatch<ParamParseKey<Path>> | null
): boolean => [RTSM_ROUTE, RTSM_ROUTE_USER_V4].some((route) => matchPath(route, pathname));

export const isRtsmWithCode = (
  pathname: string,
  matchPath?: <Path extends string>(pattern: PathPattern<Path> | Path, pathname: string) => PathMatch<ParamParseKey<Path>> | null
): boolean => {
  if (matchPath) {
    return [RTSM_ROUTE_USER_HASH, RTSM_ROUTE_USER_CODE_V4].some((route) => matchPath(route, pathname));
  }

  return rtsmWithCodePattern.test(pathname);
};

export const isRealTimeWithCode = (
  pathname: string,
  matchPath?: <Path extends string>(pattern: PathPattern<Path> | Path, pathname: string) => PathMatch<ParamParseKey<Path>> | null
): boolean => {
  if (matchPath) {
    matchPath(REAL_TIME_CODE, pathname);
  }

  return realTimeWithCodePattern.test(pathname);
};

export const isGuestRoute = (
  pathname: string,
  matchPath?: <Path extends string>(pattern: PathPattern<Path> | Path, pathname: string) => PathMatch<ParamParseKey<Path>> | null
) => isRealTimeWithCode(pathname, matchPath) || isRtsmWithCode(pathname, matchPath);
